module.exports = __webpack_public_path__ + "static/brand1-d05bfa6ea96241e46d832caa4e43f1dc.png";